/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface OfficesService {
  /** @summary List For Org */
  listForOrgOfficesListGet: {
    /** @summary List For Org */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<ListForOrgOfficesListGetSchema, ListForOrgOfficesListGetParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<ListForOrgOfficesListGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: ListForOrgOfficesListGetSchema,
        options: {
          parameters: ListForOrgOfficesListGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<ListForOrgOfficesListGetData, ListForOrgOfficesListGetError>>
    ): Promise<RequestFnResponse<ListForOrgOfficesListGetData, ListForOrgOfficesListGetError>>;
    /** @summary List For Org */
    getQueryKey(
      parameters: DeepReadonly<ListForOrgOfficesListGetParameters> | void
    ): ServiceOperationQueryKey<ListForOrgOfficesListGetSchema, ListForOrgOfficesListGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List For Org
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.officesService.listForOrgOfficesListGet.useQuery()
     * ```
     */
    useQuery<TData = ListForOrgOfficesListGetData>(
      parameters:
        | ServiceOperationQueryKey<ListForOrgOfficesListGetSchema, ListForOrgOfficesListGetParameters>
        | (DeepReadonly<ListForOrgOfficesListGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ListForOrgOfficesListGetData,
          ListForOrgOfficesListGetError,
          TData,
          ServiceOperationQueryKey<ListForOrgOfficesListGetSchema, ListForOrgOfficesListGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListForOrgOfficesListGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List For Org
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.officesService.listForOrgOfficesListGet.useQuery()
     * ```
     */
    useQuery<TData = ListForOrgOfficesListGetData>(
      parameters:
        | ServiceOperationQueryKey<ListForOrgOfficesListGetSchema, ListForOrgOfficesListGetParameters>
        | (DeepReadonly<ListForOrgOfficesListGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ListForOrgOfficesListGetData,
          ListForOrgOfficesListGetError,
          TData,
          ServiceOperationQueryKey<ListForOrgOfficesListGetSchema, ListForOrgOfficesListGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListForOrgOfficesListGetError>>;
    /** @summary List For Org */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListForOrgOfficesListGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<ListForOrgOfficesListGetSchema, ListForOrgOfficesListGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List For Org
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.officesService.listForOrgOfficesListGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListForOrgOfficesListGetParameters,
      TQueryFnData = ListForOrgOfficesListGetData,
      TData = OperationInfiniteData<TQueryFnData, ListForOrgOfficesListGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListForOrgOfficesListGetSchema, ListForOrgOfficesListGetParameters>
        | (DeepReadonly<ListForOrgOfficesListGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListForOrgOfficesListGetError,
          TData,
          ServiceOperationInfiniteQueryKey<ListForOrgOfficesListGetSchema, ListForOrgOfficesListGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListForOrgOfficesListGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List For Org
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.officesService.listForOrgOfficesListGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListForOrgOfficesListGetParameters,
      TQueryFnData = ListForOrgOfficesListGetData,
      TData = OperationInfiniteData<TQueryFnData, ListForOrgOfficesListGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListForOrgOfficesListGetSchema, ListForOrgOfficesListGetParameters>
        | (DeepReadonly<ListForOrgOfficesListGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListForOrgOfficesListGetError,
          TData,
          ServiceOperationInfiniteQueryKey<ListForOrgOfficesListGetSchema, ListForOrgOfficesListGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListForOrgOfficesListGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListForOrgOfficesListGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List For Org
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listForOrgOfficesListGetTotal = qraft.officesService.listForOrgOfficesListGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListForOrgOfficesListGetSchema,
            ListForOrgOfficesListGetData,
            TInfinite,
            ListForOrgOfficesListGetParameters,
            ListForOrgOfficesListGetError
          >
        | QueryFiltersByQueryKey<
            ListForOrgOfficesListGetSchema,
            ListForOrgOfficesListGetData,
            TInfinite,
            ListForOrgOfficesListGetParameters,
            ListForOrgOfficesListGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List For Org
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listForOrgOfficesListGetResults = qraft.officesService.listForOrgOfficesListGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listForOrgOfficesListGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listForOrgOfficesListGetCombinedResults = qraft.officesService.listForOrgOfficesListGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listForOrgOfficesListGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ListForOrgOfficesListGetSchema,
          ListForOrgOfficesListGetParameters,
          ListForOrgOfficesListGetData,
          ListForOrgOfficesListGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<ListForOrgOfficesListGetData, ListForOrgOfficesListGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<ListForOrgOfficesListGetData, ListForOrgOfficesListGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List For Org
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.officesService.listForOrgOfficesListGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = ListForOrgOfficesListGetData>(
      parameters:
        | ServiceOperationQueryKey<ListForOrgOfficesListGetSchema, ListForOrgOfficesListGetParameters>
        | (DeepReadonly<ListForOrgOfficesListGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ListForOrgOfficesListGetData,
          ListForOrgOfficesListGetError,
          TData,
          ServiceOperationQueryKey<ListForOrgOfficesListGetSchema, ListForOrgOfficesListGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListForOrgOfficesListGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List For Org
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.officesService.listForOrgOfficesListGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends ListForOrgOfficesListGetParameters,
      TData = ListForOrgOfficesListGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListForOrgOfficesListGetSchema, ListForOrgOfficesListGetParameters>
        | (DeepReadonly<ListForOrgOfficesListGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListForOrgOfficesListGetData,
          ListForOrgOfficesListGetError,
          OperationInfiniteData<TData, ListForOrgOfficesListGetParameters>,
          ServiceOperationInfiniteQueryKey<ListForOrgOfficesListGetSchema, ListForOrgOfficesListGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListForOrgOfficesListGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListForOrgOfficesListGetParameters>,
      OperationError<ListForOrgOfficesListGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List For Org
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listForOrgOfficesListGetData = qraft.officesService.listForOrgOfficesListGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listForOrgOfficesListGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listForOrgOfficesListGetCombinedData = qraft.officesService.listForOrgOfficesListGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listForOrgOfficesListGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ListForOrgOfficesListGetSchema,
          ListForOrgOfficesListGetParameters,
          ListForOrgOfficesListGetData,
          ListForOrgOfficesListGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<ListForOrgOfficesListGetData, ListForOrgOfficesListGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<UseSuspenseQueryResult<ListForOrgOfficesListGetData, ListForOrgOfficesListGetError>, 'data'>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary List For Org */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListForOrgOfficesListGetSchema,
        ListForOrgOfficesListGetData,
        ListForOrgOfficesListGetParameters,
        ListForOrgOfficesListGetError
      > | void
    ): Promise<ListForOrgOfficesListGetData>;
    /** @summary List For Org */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListForOrgOfficesListGetSchema,
        ListForOrgOfficesListGetData,
        ListForOrgOfficesListGetParameters,
        ListForOrgOfficesListGetError
      > | void
    ): Promise<void>;
    /** @summary List For Org */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListForOrgOfficesListGetSchema,
        ListForOrgOfficesListGetData,
        ListForOrgOfficesListGetParameters,
        ListForOrgOfficesListGetError
      > | void
    ): Promise<ListForOrgOfficesListGetData>;
    /** @summary List For Org */
    fetchInfiniteQuery<TPageParam extends ListForOrgOfficesListGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListForOrgOfficesListGetSchema,
        ListForOrgOfficesListGetData,
        ListForOrgOfficesListGetParameters,
        DeepReadonly<TPageParam>,
        ListForOrgOfficesListGetError
      > | void
    ): Promise<OperationInfiniteData<ListForOrgOfficesListGetData, ListForOrgOfficesListGetParameters>>;
    /** @summary List For Org */
    prefetchInfiniteQuery<TPageParam extends ListForOrgOfficesListGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListForOrgOfficesListGetSchema,
        ListForOrgOfficesListGetData,
        ListForOrgOfficesListGetParameters,
        DeepReadonly<TPageParam>,
        ListForOrgOfficesListGetError
      > | void
    ): Promise<void>;
    /** @summary List For Org */
    ensureInfiniteQueryData<TPageParam extends ListForOrgOfficesListGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListForOrgOfficesListGetSchema,
        ListForOrgOfficesListGetData,
        ListForOrgOfficesListGetParameters,
        DeepReadonly<TPageParam>,
        ListForOrgOfficesListGetError
      > | void
    ): Promise<OperationInfiniteData<ListForOrgOfficesListGetData, ListForOrgOfficesListGetParameters>>;
    /** @summary List For Org */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<ListForOrgOfficesListGetSchema, ListForOrgOfficesListGetParameters>
        | (DeepReadonly<ListForOrgOfficesListGetParameters> | void)
    ): ListForOrgOfficesListGetData | undefined;
    /** @summary List For Org */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListForOrgOfficesListGetSchema, ListForOrgOfficesListGetParameters>
        | (DeepReadonly<ListForOrgOfficesListGetParameters> | void)
    ): OperationInfiniteData<ListForOrgOfficesListGetData, ListForOrgOfficesListGetParameters> | undefined;
    /** @summary List For Org */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListForOrgOfficesListGetSchema,
            ListForOrgOfficesListGetData,
            TInfinite,
            ListForOrgOfficesListGetParameters,
            ListForOrgOfficesListGetError
          >
        | QueryFiltersByQueryKey<
            ListForOrgOfficesListGetSchema,
            ListForOrgOfficesListGetData,
            TInfinite,
            ListForOrgOfficesListGetParameters,
            ListForOrgOfficesListGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              ListForOrgOfficesListGetSchema,
              ListForOrgOfficesListGetParameters
            >,
            data:
              | NoInfer<OperationInfiniteData<ListForOrgOfficesListGetData, ListForOrgOfficesListGetParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<ListForOrgOfficesListGetSchema, ListForOrgOfficesListGetParameters>,
            data: ListForOrgOfficesListGetData | undefined,
          ]
        >;
    /** @summary List For Org */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<ListForOrgOfficesListGetSchema, ListForOrgOfficesListGetParameters>
        | (DeepReadonly<ListForOrgOfficesListGetParameters> | void)
    ): QueryState<ListForOrgOfficesListGetData, ListForOrgOfficesListGetError> | undefined;
    /** @summary List For Org */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListForOrgOfficesListGetParameters>
        | ServiceOperationInfiniteQueryKey<ListForOrgOfficesListGetSchema, ListForOrgOfficesListGetParameters>
        | void
    ):
      | QueryState<
          OperationInfiniteData<ListForOrgOfficesListGetData, ListForOrgOfficesListGetParameters>,
          ListForOrgOfficesListGetError
        >
      | undefined;
    /** @summary List For Org */
    setQueryData(
      parameters:
        | (DeepReadonly<ListForOrgOfficesListGetParameters> | undefined)
        | ServiceOperationQueryKey<ListForOrgOfficesListGetSchema, ListForOrgOfficesListGetParameters>,
      updater: Updater<
        NoInfer<ListForOrgOfficesListGetData> | undefined,
        NoInfer<DeepReadonly<ListForOrgOfficesListGetData>> | undefined
      >,
      options?: SetDataOptions
    ): ListForOrgOfficesListGetData | undefined;
    /** @summary List For Org */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ListForOrgOfficesListGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<ListForOrgOfficesListGetSchema, ListForOrgOfficesListGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<ListForOrgOfficesListGetData, ListForOrgOfficesListGetParameters>> | undefined,
        | NoInfer<DeepReadonly<OperationInfiniteData<ListForOrgOfficesListGetData, ListForOrgOfficesListGetParameters>>>
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<ListForOrgOfficesListGetData, ListForOrgOfficesListGetParameters> | undefined;
    /** @summary List For Org */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ListForOrgOfficesListGetSchema,
            ListForOrgOfficesListGetData,
            TInfinite,
            ListForOrgOfficesListGetParameters,
            ListForOrgOfficesListGetError
          >
        | QueryFiltersByQueryKey<
            ListForOrgOfficesListGetSchema,
            ListForOrgOfficesListGetData,
            TInfinite,
            ListForOrgOfficesListGetParameters,
            ListForOrgOfficesListGetError
          >,
      updater: Updater<
        NoInfer<ListForOrgOfficesListGetData> | undefined,
        NoInfer<ListForOrgOfficesListGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<ListForOrgOfficesListGetData | undefined>;
    /** @summary List For Org */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListForOrgOfficesListGetSchema,
        ListForOrgOfficesListGetData,
        TInfinite,
        ListForOrgOfficesListGetParameters,
        ListForOrgOfficesListGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary List For Org */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListForOrgOfficesListGetSchema,
            ListForOrgOfficesListGetData,
            TInfinite,
            ListForOrgOfficesListGetParameters,
            ListForOrgOfficesListGetError
          >
        | QueryFiltersByQueryKey<
            ListForOrgOfficesListGetSchema,
            ListForOrgOfficesListGetData,
            TInfinite,
            ListForOrgOfficesListGetParameters,
            ListForOrgOfficesListGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary List For Org */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListForOrgOfficesListGetSchema,
            ListForOrgOfficesListGetData,
            TInfinite,
            ListForOrgOfficesListGetParameters,
            ListForOrgOfficesListGetError
          >
        | QueryFiltersByQueryKey<
            ListForOrgOfficesListGetSchema,
            ListForOrgOfficesListGetData,
            TInfinite,
            ListForOrgOfficesListGetParameters,
            ListForOrgOfficesListGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary List For Org */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListForOrgOfficesListGetSchema,
            ListForOrgOfficesListGetData,
            TInfinite,
            ListForOrgOfficesListGetParameters,
            ListForOrgOfficesListGetError
          >
        | QueryFiltersByQueryKey<
            ListForOrgOfficesListGetSchema,
            ListForOrgOfficesListGetData,
            TInfinite,
            ListForOrgOfficesListGetParameters,
            ListForOrgOfficesListGetError
          >
    ): void;
    /** @summary List For Org */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListForOrgOfficesListGetSchema,
            ListForOrgOfficesListGetData,
            TInfinite,
            ListForOrgOfficesListGetParameters,
            ListForOrgOfficesListGetError
          >
        | QueryFiltersByQueryKey<
            ListForOrgOfficesListGetSchema,
            ListForOrgOfficesListGetData,
            TInfinite,
            ListForOrgOfficesListGetParameters,
            ListForOrgOfficesListGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary List For Org */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListForOrgOfficesListGetSchema,
            ListForOrgOfficesListGetData,
            TInfinite,
            ListForOrgOfficesListGetParameters,
            ListForOrgOfficesListGetError
          >
        | QueryFiltersByQueryKey<
            ListForOrgOfficesListGetSchema,
            ListForOrgOfficesListGetData,
            TInfinite,
            ListForOrgOfficesListGetParameters,
            ListForOrgOfficesListGetError
          >
    ): number;
    schema: ListForOrgOfficesListGetSchema;
    types: {
      parameters: ListForOrgOfficesListGetParameters;
      data: ListForOrgOfficesListGetData;
      error: ListForOrgOfficesListGetError;
    };
  };
  /** @summary List All */
  listAllOffices: {
    /** @summary List All */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<ListAllOfficesSchema, ListAllOfficesParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<ListAllOfficesParameters, TMeta, TSignal> | void),
      client?: (
        schema: ListAllOfficesSchema,
        options: {
          parameters: ListAllOfficesParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<ListAllOfficesData, ListAllOfficesError>>
    ): Promise<RequestFnResponse<ListAllOfficesData, ListAllOfficesError>>;
    /** @summary List All */
    getQueryKey(
      parameters: DeepReadonly<ListAllOfficesParameters> | void
    ): ServiceOperationQueryKey<ListAllOfficesSchema, ListAllOfficesParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.officesService.listAllOffices.useQuery()
     * ```
     */
    useQuery<TData = ListAllOfficesData>(
      parameters:
        | ServiceOperationQueryKey<ListAllOfficesSchema, ListAllOfficesParameters>
        | (DeepReadonly<ListAllOfficesParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ListAllOfficesData,
          ListAllOfficesError,
          TData,
          ServiceOperationQueryKey<ListAllOfficesSchema, ListAllOfficesParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListAllOfficesError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.officesService.listAllOffices.useQuery()
     * ```
     */
    useQuery<TData = ListAllOfficesData>(
      parameters:
        | ServiceOperationQueryKey<ListAllOfficesSchema, ListAllOfficesParameters>
        | (DeepReadonly<ListAllOfficesParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ListAllOfficesData,
          ListAllOfficesError,
          TData,
          ServiceOperationQueryKey<ListAllOfficesSchema, ListAllOfficesParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListAllOfficesError>>;
    /** @summary List All */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListAllOfficesParameters> | void
    ): ServiceOperationInfiniteQueryKey<ListAllOfficesSchema, ListAllOfficesParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.officesService.listAllOffices.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListAllOfficesParameters,
      TQueryFnData = ListAllOfficesData,
      TData = OperationInfiniteData<TQueryFnData, ListAllOfficesParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListAllOfficesSchema, ListAllOfficesParameters>
        | (DeepReadonly<ListAllOfficesParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListAllOfficesError,
          TData,
          ServiceOperationInfiniteQueryKey<ListAllOfficesSchema, ListAllOfficesParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListAllOfficesError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.officesService.listAllOffices.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListAllOfficesParameters,
      TQueryFnData = ListAllOfficesData,
      TData = OperationInfiniteData<TQueryFnData, ListAllOfficesParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListAllOfficesSchema, ListAllOfficesParameters>
        | (DeepReadonly<ListAllOfficesParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListAllOfficesError,
          TData,
          ServiceOperationInfiniteQueryKey<ListAllOfficesSchema, ListAllOfficesParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListAllOfficesData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListAllOfficesError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listAllOfficesTotal = qraft.officesService.listAllOffices.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAllOfficesSchema,
            ListAllOfficesData,
            TInfinite,
            ListAllOfficesParameters,
            ListAllOfficesError
          >
        | QueryFiltersByQueryKey<
            ListAllOfficesSchema,
            ListAllOfficesData,
            TInfinite,
            ListAllOfficesParameters,
            ListAllOfficesError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listAllOfficesResults = qraft.officesService.listAllOffices.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listAllOfficesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listAllOfficesCombinedResults = qraft.officesService.listAllOffices.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listAllOfficesCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ListAllOfficesSchema,
          ListAllOfficesParameters,
          ListAllOfficesData,
          ListAllOfficesError
        >
      >,
      TCombinedResult = Array<UseQueryResult<ListAllOfficesData, ListAllOfficesError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<ListAllOfficesData, ListAllOfficesError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.officesService.listAllOffices.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = ListAllOfficesData>(
      parameters:
        | ServiceOperationQueryKey<ListAllOfficesSchema, ListAllOfficesParameters>
        | (DeepReadonly<ListAllOfficesParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ListAllOfficesData,
          ListAllOfficesError,
          TData,
          ServiceOperationQueryKey<ListAllOfficesSchema, ListAllOfficesParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListAllOfficesError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.officesService.listAllOffices.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends ListAllOfficesParameters, TData = ListAllOfficesData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListAllOfficesSchema, ListAllOfficesParameters>
        | (DeepReadonly<ListAllOfficesParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListAllOfficesData,
          ListAllOfficesError,
          OperationInfiniteData<TData, ListAllOfficesParameters>,
          ServiceOperationInfiniteQueryKey<ListAllOfficesSchema, ListAllOfficesParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListAllOfficesData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListAllOfficesParameters>,
      OperationError<ListAllOfficesError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listAllOfficesData = qraft.officesService.listAllOffices.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listAllOfficesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listAllOfficesCombinedData = qraft.officesService.listAllOffices.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listAllOfficesCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ListAllOfficesSchema,
          ListAllOfficesParameters,
          ListAllOfficesData,
          ListAllOfficesError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<ListAllOfficesData, ListAllOfficesError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<ListAllOfficesData, ListAllOfficesError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary List All */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListAllOfficesSchema,
        ListAllOfficesData,
        ListAllOfficesParameters,
        ListAllOfficesError
      > | void
    ): Promise<ListAllOfficesData>;
    /** @summary List All */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListAllOfficesSchema,
        ListAllOfficesData,
        ListAllOfficesParameters,
        ListAllOfficesError
      > | void
    ): Promise<void>;
    /** @summary List All */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListAllOfficesSchema,
        ListAllOfficesData,
        ListAllOfficesParameters,
        ListAllOfficesError
      > | void
    ): Promise<ListAllOfficesData>;
    /** @summary List All */
    fetchInfiniteQuery<TPageParam extends ListAllOfficesParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListAllOfficesSchema,
        ListAllOfficesData,
        ListAllOfficesParameters,
        DeepReadonly<TPageParam>,
        ListAllOfficesError
      > | void
    ): Promise<OperationInfiniteData<ListAllOfficesData, ListAllOfficesParameters>>;
    /** @summary List All */
    prefetchInfiniteQuery<TPageParam extends ListAllOfficesParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListAllOfficesSchema,
        ListAllOfficesData,
        ListAllOfficesParameters,
        DeepReadonly<TPageParam>,
        ListAllOfficesError
      > | void
    ): Promise<void>;
    /** @summary List All */
    ensureInfiniteQueryData<TPageParam extends ListAllOfficesParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListAllOfficesSchema,
        ListAllOfficesData,
        ListAllOfficesParameters,
        DeepReadonly<TPageParam>,
        ListAllOfficesError
      > | void
    ): Promise<OperationInfiniteData<ListAllOfficesData, ListAllOfficesParameters>>;
    /** @summary List All */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<ListAllOfficesSchema, ListAllOfficesParameters>
        | (DeepReadonly<ListAllOfficesParameters> | void)
    ): ListAllOfficesData | undefined;
    /** @summary List All */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListAllOfficesSchema, ListAllOfficesParameters>
        | (DeepReadonly<ListAllOfficesParameters> | void)
    ): OperationInfiniteData<ListAllOfficesData, ListAllOfficesParameters> | undefined;
    /** @summary List All */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAllOfficesSchema,
            ListAllOfficesData,
            TInfinite,
            ListAllOfficesParameters,
            ListAllOfficesError
          >
        | QueryFiltersByQueryKey<
            ListAllOfficesSchema,
            ListAllOfficesData,
            TInfinite,
            ListAllOfficesParameters,
            ListAllOfficesError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<ListAllOfficesSchema, ListAllOfficesParameters>,
            data: NoInfer<OperationInfiniteData<ListAllOfficesData, ListAllOfficesParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<ListAllOfficesSchema, ListAllOfficesParameters>,
            data: ListAllOfficesData | undefined,
          ]
        >;
    /** @summary List All */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<ListAllOfficesSchema, ListAllOfficesParameters>
        | (DeepReadonly<ListAllOfficesParameters> | void)
    ): QueryState<ListAllOfficesData, ListAllOfficesError> | undefined;
    /** @summary List All */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListAllOfficesParameters>
        | ServiceOperationInfiniteQueryKey<ListAllOfficesSchema, ListAllOfficesParameters>
        | void
    ): QueryState<OperationInfiniteData<ListAllOfficesData, ListAllOfficesParameters>, ListAllOfficesError> | undefined;
    /** @summary List All */
    setQueryData(
      parameters:
        | (DeepReadonly<ListAllOfficesParameters> | undefined)
        | ServiceOperationQueryKey<ListAllOfficesSchema, ListAllOfficesParameters>,
      updater: Updater<NoInfer<ListAllOfficesData> | undefined, NoInfer<DeepReadonly<ListAllOfficesData>> | undefined>,
      options?: SetDataOptions
    ): ListAllOfficesData | undefined;
    /** @summary List All */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ListAllOfficesParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<ListAllOfficesSchema, ListAllOfficesParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<ListAllOfficesData, ListAllOfficesParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<ListAllOfficesData, ListAllOfficesParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<ListAllOfficesData, ListAllOfficesParameters> | undefined;
    /** @summary List All */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ListAllOfficesSchema,
            ListAllOfficesData,
            TInfinite,
            ListAllOfficesParameters,
            ListAllOfficesError
          >
        | QueryFiltersByQueryKey<
            ListAllOfficesSchema,
            ListAllOfficesData,
            TInfinite,
            ListAllOfficesParameters,
            ListAllOfficesError
          >,
      updater: Updater<NoInfer<ListAllOfficesData> | undefined, NoInfer<ListAllOfficesData> | undefined>,
      options?: SetDataOptions
    ): Array<ListAllOfficesData | undefined>;
    /** @summary List All */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListAllOfficesSchema,
        ListAllOfficesData,
        TInfinite,
        ListAllOfficesParameters,
        ListAllOfficesError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary List All */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAllOfficesSchema,
            ListAllOfficesData,
            TInfinite,
            ListAllOfficesParameters,
            ListAllOfficesError
          >
        | QueryFiltersByQueryKey<
            ListAllOfficesSchema,
            ListAllOfficesData,
            TInfinite,
            ListAllOfficesParameters,
            ListAllOfficesError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary List All */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAllOfficesSchema,
            ListAllOfficesData,
            TInfinite,
            ListAllOfficesParameters,
            ListAllOfficesError
          >
        | QueryFiltersByQueryKey<
            ListAllOfficesSchema,
            ListAllOfficesData,
            TInfinite,
            ListAllOfficesParameters,
            ListAllOfficesError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary List All */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAllOfficesSchema,
            ListAllOfficesData,
            TInfinite,
            ListAllOfficesParameters,
            ListAllOfficesError
          >
        | QueryFiltersByQueryKey<
            ListAllOfficesSchema,
            ListAllOfficesData,
            TInfinite,
            ListAllOfficesParameters,
            ListAllOfficesError
          >
    ): void;
    /** @summary List All */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAllOfficesSchema,
            ListAllOfficesData,
            TInfinite,
            ListAllOfficesParameters,
            ListAllOfficesError
          >
        | QueryFiltersByQueryKey<
            ListAllOfficesSchema,
            ListAllOfficesData,
            TInfinite,
            ListAllOfficesParameters,
            ListAllOfficesError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary List All */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAllOfficesSchema,
            ListAllOfficesData,
            TInfinite,
            ListAllOfficesParameters,
            ListAllOfficesError
          >
        | QueryFiltersByQueryKey<
            ListAllOfficesSchema,
            ListAllOfficesData,
            TInfinite,
            ListAllOfficesParameters,
            ListAllOfficesError
          >
    ): number;
    schema: ListAllOfficesSchema;
    types: {
      parameters: ListAllOfficesParameters;
      data: ListAllOfficesData;
      error: ListAllOfficesError;
    };
  };
  /** @summary Get Active */
  getActiveOfficesActiveGet: {
    /** @summary Get Active */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetActiveOfficesActiveGetSchema, GetActiveOfficesActiveGetParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<GetActiveOfficesActiveGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetActiveOfficesActiveGetSchema,
        options: {
          parameters: GetActiveOfficesActiveGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetActiveOfficesActiveGetData, GetActiveOfficesActiveGetError>>
    ): Promise<RequestFnResponse<GetActiveOfficesActiveGetData, GetActiveOfficesActiveGetError>>;
    /** @summary Get Active */
    getQueryKey(
      parameters: DeepReadonly<GetActiveOfficesActiveGetParameters> | void
    ): ServiceOperationQueryKey<GetActiveOfficesActiveGetSchema, GetActiveOfficesActiveGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Active
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.officesService.getActiveOfficesActiveGet.useQuery()
     * ```
     */
    useQuery<TData = GetActiveOfficesActiveGetData>(
      parameters:
        | ServiceOperationQueryKey<GetActiveOfficesActiveGetSchema, GetActiveOfficesActiveGetParameters>
        | (DeepReadonly<GetActiveOfficesActiveGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetActiveOfficesActiveGetData,
          GetActiveOfficesActiveGetError,
          TData,
          ServiceOperationQueryKey<GetActiveOfficesActiveGetSchema, GetActiveOfficesActiveGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetActiveOfficesActiveGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Active
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.officesService.getActiveOfficesActiveGet.useQuery()
     * ```
     */
    useQuery<TData = GetActiveOfficesActiveGetData>(
      parameters:
        | ServiceOperationQueryKey<GetActiveOfficesActiveGetSchema, GetActiveOfficesActiveGetParameters>
        | (DeepReadonly<GetActiveOfficesActiveGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetActiveOfficesActiveGetData,
          GetActiveOfficesActiveGetError,
          TData,
          ServiceOperationQueryKey<GetActiveOfficesActiveGetSchema, GetActiveOfficesActiveGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetActiveOfficesActiveGetError>>;
    /** @summary Get Active */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetActiveOfficesActiveGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<GetActiveOfficesActiveGetSchema, GetActiveOfficesActiveGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Active
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.officesService.getActiveOfficesActiveGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetActiveOfficesActiveGetParameters,
      TQueryFnData = GetActiveOfficesActiveGetData,
      TData = OperationInfiniteData<TQueryFnData, GetActiveOfficesActiveGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetActiveOfficesActiveGetSchema, GetActiveOfficesActiveGetParameters>
        | (DeepReadonly<GetActiveOfficesActiveGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetActiveOfficesActiveGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetActiveOfficesActiveGetSchema, GetActiveOfficesActiveGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetActiveOfficesActiveGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Active
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.officesService.getActiveOfficesActiveGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetActiveOfficesActiveGetParameters,
      TQueryFnData = GetActiveOfficesActiveGetData,
      TData = OperationInfiniteData<TQueryFnData, GetActiveOfficesActiveGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetActiveOfficesActiveGetSchema, GetActiveOfficesActiveGetParameters>
        | (DeepReadonly<GetActiveOfficesActiveGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetActiveOfficesActiveGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetActiveOfficesActiveGetSchema, GetActiveOfficesActiveGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetActiveOfficesActiveGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetActiveOfficesActiveGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Active
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getActiveOfficesActiveGetTotal = qraft.officesService.getActiveOfficesActiveGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetActiveOfficesActiveGetSchema,
            GetActiveOfficesActiveGetData,
            TInfinite,
            GetActiveOfficesActiveGetParameters,
            GetActiveOfficesActiveGetError
          >
        | QueryFiltersByQueryKey<
            GetActiveOfficesActiveGetSchema,
            GetActiveOfficesActiveGetData,
            TInfinite,
            GetActiveOfficesActiveGetParameters,
            GetActiveOfficesActiveGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Active
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getActiveOfficesActiveGetResults = qraft.officesService.getActiveOfficesActiveGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getActiveOfficesActiveGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getActiveOfficesActiveGetCombinedResults = qraft.officesService.getActiveOfficesActiveGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getActiveOfficesActiveGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetActiveOfficesActiveGetSchema,
          GetActiveOfficesActiveGetParameters,
          GetActiveOfficesActiveGetData,
          GetActiveOfficesActiveGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetActiveOfficesActiveGetData, GetActiveOfficesActiveGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<GetActiveOfficesActiveGetData, GetActiveOfficesActiveGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Active
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.officesService.getActiveOfficesActiveGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = GetActiveOfficesActiveGetData>(
      parameters:
        | ServiceOperationQueryKey<GetActiveOfficesActiveGetSchema, GetActiveOfficesActiveGetParameters>
        | (DeepReadonly<GetActiveOfficesActiveGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetActiveOfficesActiveGetData,
          GetActiveOfficesActiveGetError,
          TData,
          ServiceOperationQueryKey<GetActiveOfficesActiveGetSchema, GetActiveOfficesActiveGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetActiveOfficesActiveGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Active
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.officesService.getActiveOfficesActiveGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetActiveOfficesActiveGetParameters,
      TData = GetActiveOfficesActiveGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetActiveOfficesActiveGetSchema, GetActiveOfficesActiveGetParameters>
        | (DeepReadonly<GetActiveOfficesActiveGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetActiveOfficesActiveGetData,
          GetActiveOfficesActiveGetError,
          OperationInfiniteData<TData, GetActiveOfficesActiveGetParameters>,
          ServiceOperationInfiniteQueryKey<GetActiveOfficesActiveGetSchema, GetActiveOfficesActiveGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetActiveOfficesActiveGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetActiveOfficesActiveGetParameters>,
      OperationError<GetActiveOfficesActiveGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Active
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getActiveOfficesActiveGetData = qraft.officesService.getActiveOfficesActiveGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getActiveOfficesActiveGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getActiveOfficesActiveGetCombinedData = qraft.officesService.getActiveOfficesActiveGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getActiveOfficesActiveGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetActiveOfficesActiveGetSchema,
          GetActiveOfficesActiveGetParameters,
          GetActiveOfficesActiveGetData,
          GetActiveOfficesActiveGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetActiveOfficesActiveGetData, GetActiveOfficesActiveGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<UseSuspenseQueryResult<GetActiveOfficesActiveGetData, GetActiveOfficesActiveGetError>, 'data'>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get Active */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetActiveOfficesActiveGetSchema,
        GetActiveOfficesActiveGetData,
        GetActiveOfficesActiveGetParameters,
        GetActiveOfficesActiveGetError
      > | void
    ): Promise<GetActiveOfficesActiveGetData>;
    /** @summary Get Active */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetActiveOfficesActiveGetSchema,
        GetActiveOfficesActiveGetData,
        GetActiveOfficesActiveGetParameters,
        GetActiveOfficesActiveGetError
      > | void
    ): Promise<void>;
    /** @summary Get Active */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetActiveOfficesActiveGetSchema,
        GetActiveOfficesActiveGetData,
        GetActiveOfficesActiveGetParameters,
        GetActiveOfficesActiveGetError
      > | void
    ): Promise<GetActiveOfficesActiveGetData>;
    /** @summary Get Active */
    fetchInfiniteQuery<TPageParam extends GetActiveOfficesActiveGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetActiveOfficesActiveGetSchema,
        GetActiveOfficesActiveGetData,
        GetActiveOfficesActiveGetParameters,
        DeepReadonly<TPageParam>,
        GetActiveOfficesActiveGetError
      > | void
    ): Promise<OperationInfiniteData<GetActiveOfficesActiveGetData, GetActiveOfficesActiveGetParameters>>;
    /** @summary Get Active */
    prefetchInfiniteQuery<TPageParam extends GetActiveOfficesActiveGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetActiveOfficesActiveGetSchema,
        GetActiveOfficesActiveGetData,
        GetActiveOfficesActiveGetParameters,
        DeepReadonly<TPageParam>,
        GetActiveOfficesActiveGetError
      > | void
    ): Promise<void>;
    /** @summary Get Active */
    ensureInfiniteQueryData<TPageParam extends GetActiveOfficesActiveGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetActiveOfficesActiveGetSchema,
        GetActiveOfficesActiveGetData,
        GetActiveOfficesActiveGetParameters,
        DeepReadonly<TPageParam>,
        GetActiveOfficesActiveGetError
      > | void
    ): Promise<OperationInfiniteData<GetActiveOfficesActiveGetData, GetActiveOfficesActiveGetParameters>>;
    /** @summary Get Active */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetActiveOfficesActiveGetSchema, GetActiveOfficesActiveGetParameters>
        | (DeepReadonly<GetActiveOfficesActiveGetParameters> | void)
    ): GetActiveOfficesActiveGetData | undefined;
    /** @summary Get Active */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetActiveOfficesActiveGetSchema, GetActiveOfficesActiveGetParameters>
        | (DeepReadonly<GetActiveOfficesActiveGetParameters> | void)
    ): OperationInfiniteData<GetActiveOfficesActiveGetData, GetActiveOfficesActiveGetParameters> | undefined;
    /** @summary Get Active */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetActiveOfficesActiveGetSchema,
            GetActiveOfficesActiveGetData,
            TInfinite,
            GetActiveOfficesActiveGetParameters,
            GetActiveOfficesActiveGetError
          >
        | QueryFiltersByQueryKey<
            GetActiveOfficesActiveGetSchema,
            GetActiveOfficesActiveGetData,
            TInfinite,
            GetActiveOfficesActiveGetParameters,
            GetActiveOfficesActiveGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetActiveOfficesActiveGetSchema,
              GetActiveOfficesActiveGetParameters
            >,
            data:
              | NoInfer<OperationInfiniteData<GetActiveOfficesActiveGetData, GetActiveOfficesActiveGetParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetActiveOfficesActiveGetSchema, GetActiveOfficesActiveGetParameters>,
            data: GetActiveOfficesActiveGetData | undefined,
          ]
        >;
    /** @summary Get Active */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetActiveOfficesActiveGetSchema, GetActiveOfficesActiveGetParameters>
        | (DeepReadonly<GetActiveOfficesActiveGetParameters> | void)
    ): QueryState<GetActiveOfficesActiveGetData, GetActiveOfficesActiveGetError> | undefined;
    /** @summary Get Active */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetActiveOfficesActiveGetParameters>
        | ServiceOperationInfiniteQueryKey<GetActiveOfficesActiveGetSchema, GetActiveOfficesActiveGetParameters>
        | void
    ):
      | QueryState<
          OperationInfiniteData<GetActiveOfficesActiveGetData, GetActiveOfficesActiveGetParameters>,
          GetActiveOfficesActiveGetError
        >
      | undefined;
    /** @summary Get Active */
    setQueryData(
      parameters:
        | (DeepReadonly<GetActiveOfficesActiveGetParameters> | undefined)
        | ServiceOperationQueryKey<GetActiveOfficesActiveGetSchema, GetActiveOfficesActiveGetParameters>,
      updater: Updater<
        NoInfer<GetActiveOfficesActiveGetData> | undefined,
        NoInfer<DeepReadonly<GetActiveOfficesActiveGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetActiveOfficesActiveGetData | undefined;
    /** @summary Get Active */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetActiveOfficesActiveGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<GetActiveOfficesActiveGetSchema, GetActiveOfficesActiveGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetActiveOfficesActiveGetData, GetActiveOfficesActiveGetParameters>> | undefined,
        | NoInfer<
            DeepReadonly<OperationInfiniteData<GetActiveOfficesActiveGetData, GetActiveOfficesActiveGetParameters>>
          >
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetActiveOfficesActiveGetData, GetActiveOfficesActiveGetParameters> | undefined;
    /** @summary Get Active */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetActiveOfficesActiveGetSchema,
            GetActiveOfficesActiveGetData,
            TInfinite,
            GetActiveOfficesActiveGetParameters,
            GetActiveOfficesActiveGetError
          >
        | QueryFiltersByQueryKey<
            GetActiveOfficesActiveGetSchema,
            GetActiveOfficesActiveGetData,
            TInfinite,
            GetActiveOfficesActiveGetParameters,
            GetActiveOfficesActiveGetError
          >,
      updater: Updater<
        NoInfer<GetActiveOfficesActiveGetData> | undefined,
        NoInfer<GetActiveOfficesActiveGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetActiveOfficesActiveGetData | undefined>;
    /** @summary Get Active */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetActiveOfficesActiveGetSchema,
        GetActiveOfficesActiveGetData,
        TInfinite,
        GetActiveOfficesActiveGetParameters,
        GetActiveOfficesActiveGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get Active */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetActiveOfficesActiveGetSchema,
            GetActiveOfficesActiveGetData,
            TInfinite,
            GetActiveOfficesActiveGetParameters,
            GetActiveOfficesActiveGetError
          >
        | QueryFiltersByQueryKey<
            GetActiveOfficesActiveGetSchema,
            GetActiveOfficesActiveGetData,
            TInfinite,
            GetActiveOfficesActiveGetParameters,
            GetActiveOfficesActiveGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get Active */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetActiveOfficesActiveGetSchema,
            GetActiveOfficesActiveGetData,
            TInfinite,
            GetActiveOfficesActiveGetParameters,
            GetActiveOfficesActiveGetError
          >
        | QueryFiltersByQueryKey<
            GetActiveOfficesActiveGetSchema,
            GetActiveOfficesActiveGetData,
            TInfinite,
            GetActiveOfficesActiveGetParameters,
            GetActiveOfficesActiveGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get Active */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetActiveOfficesActiveGetSchema,
            GetActiveOfficesActiveGetData,
            TInfinite,
            GetActiveOfficesActiveGetParameters,
            GetActiveOfficesActiveGetError
          >
        | QueryFiltersByQueryKey<
            GetActiveOfficesActiveGetSchema,
            GetActiveOfficesActiveGetData,
            TInfinite,
            GetActiveOfficesActiveGetParameters,
            GetActiveOfficesActiveGetError
          >
    ): void;
    /** @summary Get Active */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetActiveOfficesActiveGetSchema,
            GetActiveOfficesActiveGetData,
            TInfinite,
            GetActiveOfficesActiveGetParameters,
            GetActiveOfficesActiveGetError
          >
        | QueryFiltersByQueryKey<
            GetActiveOfficesActiveGetSchema,
            GetActiveOfficesActiveGetData,
            TInfinite,
            GetActiveOfficesActiveGetParameters,
            GetActiveOfficesActiveGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get Active */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetActiveOfficesActiveGetSchema,
            GetActiveOfficesActiveGetData,
            TInfinite,
            GetActiveOfficesActiveGetParameters,
            GetActiveOfficesActiveGetError
          >
        | QueryFiltersByQueryKey<
            GetActiveOfficesActiveGetSchema,
            GetActiveOfficesActiveGetData,
            TInfinite,
            GetActiveOfficesActiveGetParameters,
            GetActiveOfficesActiveGetError
          >
    ): number;
    schema: GetActiveOfficesActiveGetSchema;
    types: {
      parameters: GetActiveOfficesActiveGetParameters;
      data: GetActiveOfficesActiveGetData;
      error: GetActiveOfficesActiveGetError;
    };
  };
  /** @summary Get */
  getOfficesOfficeIdGet: {
    /** @summary Get */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetOfficesOfficeIdGetSchema, GetOfficesOfficeIdGetParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<GetOfficesOfficeIdGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetOfficesOfficeIdGetSchema,
        options: {
          parameters: GetOfficesOfficeIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetOfficesOfficeIdGetData, GetOfficesOfficeIdGetError>>
    ): Promise<RequestFnResponse<GetOfficesOfficeIdGetData, GetOfficesOfficeIdGetError>>;
    /** @summary Get */
    getQueryKey(
      parameters: DeepReadonly<GetOfficesOfficeIdGetParameters>
    ): ServiceOperationQueryKey<GetOfficesOfficeIdGetSchema, GetOfficesOfficeIdGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.officesService.getOfficesOfficeIdGet.useQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetOfficesOfficeIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetOfficesOfficeIdGetSchema, GetOfficesOfficeIdGetParameters>
        | DeepReadonly<GetOfficesOfficeIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetOfficesOfficeIdGetData,
          GetOfficesOfficeIdGetError,
          TData,
          ServiceOperationQueryKey<GetOfficesOfficeIdGetSchema, GetOfficesOfficeIdGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetOfficesOfficeIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.officesService.getOfficesOfficeIdGet.useQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetOfficesOfficeIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetOfficesOfficeIdGetSchema, GetOfficesOfficeIdGetParameters>
        | DeepReadonly<GetOfficesOfficeIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetOfficesOfficeIdGetData,
          GetOfficesOfficeIdGetError,
          TData,
          ServiceOperationQueryKey<GetOfficesOfficeIdGetSchema, GetOfficesOfficeIdGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetOfficesOfficeIdGetError>>;
    /** @summary Get */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetOfficesOfficeIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<GetOfficesOfficeIdGetSchema, GetOfficesOfficeIdGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.officesService.getOfficesOfficeIdGet.useInfiniteQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetOfficesOfficeIdGetParameters,
      TQueryFnData = GetOfficesOfficeIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetOfficesOfficeIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetOfficesOfficeIdGetSchema, GetOfficesOfficeIdGetParameters>
        | DeepReadonly<GetOfficesOfficeIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetOfficesOfficeIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetOfficesOfficeIdGetSchema, GetOfficesOfficeIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetOfficesOfficeIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.officesService.getOfficesOfficeIdGet.useInfiniteQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetOfficesOfficeIdGetParameters,
      TQueryFnData = GetOfficesOfficeIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetOfficesOfficeIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetOfficesOfficeIdGetSchema, GetOfficesOfficeIdGetParameters>
        | DeepReadonly<GetOfficesOfficeIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetOfficesOfficeIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetOfficesOfficeIdGetSchema, GetOfficesOfficeIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetOfficesOfficeIdGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetOfficesOfficeIdGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getOfficesOfficeIdGetTotal = qraft.officesService.getOfficesOfficeIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getOfficesOfficeIdGetByParametersTotal = qraft.officesService.getOfficesOfficeIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetOfficesOfficeIdGetSchema,
            GetOfficesOfficeIdGetData,
            TInfinite,
            GetOfficesOfficeIdGetParameters,
            GetOfficesOfficeIdGetError
          >
        | QueryFiltersByQueryKey<
            GetOfficesOfficeIdGetSchema,
            GetOfficesOfficeIdGetData,
            TInfinite,
            GetOfficesOfficeIdGetParameters,
            GetOfficesOfficeIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getOfficesOfficeIdGetResults = qraft.officesService.getOfficesOfficeIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getOfficesOfficeIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getOfficesOfficeIdGetCombinedResults = qraft.officesService.getOfficesOfficeIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getOfficesOfficeIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetOfficesOfficeIdGetSchema,
          GetOfficesOfficeIdGetParameters,
          GetOfficesOfficeIdGetData,
          GetOfficesOfficeIdGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetOfficesOfficeIdGetData, GetOfficesOfficeIdGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<GetOfficesOfficeIdGetData, GetOfficesOfficeIdGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.officesService.getOfficesOfficeIdGet.useSuspenseQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetOfficesOfficeIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetOfficesOfficeIdGetSchema, GetOfficesOfficeIdGetParameters>
        | DeepReadonly<GetOfficesOfficeIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetOfficesOfficeIdGetData,
          GetOfficesOfficeIdGetError,
          TData,
          ServiceOperationQueryKey<GetOfficesOfficeIdGetSchema, GetOfficesOfficeIdGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetOfficesOfficeIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.officesService.getOfficesOfficeIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetOfficesOfficeIdGetParameters, TData = GetOfficesOfficeIdGetData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetOfficesOfficeIdGetSchema, GetOfficesOfficeIdGetParameters>
        | DeepReadonly<GetOfficesOfficeIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetOfficesOfficeIdGetData,
          GetOfficesOfficeIdGetError,
          OperationInfiniteData<TData, GetOfficesOfficeIdGetParameters>,
          ServiceOperationInfiniteQueryKey<GetOfficesOfficeIdGetSchema, GetOfficesOfficeIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetOfficesOfficeIdGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetOfficesOfficeIdGetParameters>,
      OperationError<GetOfficesOfficeIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getOfficesOfficeIdGetData = qraft.officesService.getOfficesOfficeIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getOfficesOfficeIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getOfficesOfficeIdGetCombinedData = qraft.officesService.getOfficesOfficeIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getOfficesOfficeIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetOfficesOfficeIdGetSchema,
          GetOfficesOfficeIdGetParameters,
          GetOfficesOfficeIdGetData,
          GetOfficesOfficeIdGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetOfficesOfficeIdGetData, GetOfficesOfficeIdGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<UseSuspenseQueryResult<GetOfficesOfficeIdGetData, GetOfficesOfficeIdGetError>, 'data'>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetOfficesOfficeIdGetSchema,
        GetOfficesOfficeIdGetData,
        GetOfficesOfficeIdGetParameters,
        GetOfficesOfficeIdGetError
      >
    ): Promise<GetOfficesOfficeIdGetData>;
    /** @summary Get */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetOfficesOfficeIdGetSchema,
        GetOfficesOfficeIdGetData,
        GetOfficesOfficeIdGetParameters,
        GetOfficesOfficeIdGetError
      >
    ): Promise<void>;
    /** @summary Get */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetOfficesOfficeIdGetSchema,
        GetOfficesOfficeIdGetData,
        GetOfficesOfficeIdGetParameters,
        GetOfficesOfficeIdGetError
      >
    ): Promise<GetOfficesOfficeIdGetData>;
    /** @summary Get */
    fetchInfiniteQuery<TPageParam extends GetOfficesOfficeIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetOfficesOfficeIdGetSchema,
        GetOfficesOfficeIdGetData,
        GetOfficesOfficeIdGetParameters,
        DeepReadonly<TPageParam>,
        GetOfficesOfficeIdGetError
      >
    ): Promise<OperationInfiniteData<GetOfficesOfficeIdGetData, GetOfficesOfficeIdGetParameters>>;
    /** @summary Get */
    prefetchInfiniteQuery<TPageParam extends GetOfficesOfficeIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetOfficesOfficeIdGetSchema,
        GetOfficesOfficeIdGetData,
        GetOfficesOfficeIdGetParameters,
        DeepReadonly<TPageParam>,
        GetOfficesOfficeIdGetError
      >
    ): Promise<void>;
    /** @summary Get */
    ensureInfiniteQueryData<TPageParam extends GetOfficesOfficeIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetOfficesOfficeIdGetSchema,
        GetOfficesOfficeIdGetData,
        GetOfficesOfficeIdGetParameters,
        DeepReadonly<TPageParam>,
        GetOfficesOfficeIdGetError
      >
    ): Promise<OperationInfiniteData<GetOfficesOfficeIdGetData, GetOfficesOfficeIdGetParameters>>;
    /** @summary Get */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetOfficesOfficeIdGetSchema, GetOfficesOfficeIdGetParameters>
        | DeepReadonly<GetOfficesOfficeIdGetParameters>
    ): GetOfficesOfficeIdGetData | undefined;
    /** @summary Get */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetOfficesOfficeIdGetSchema, GetOfficesOfficeIdGetParameters>
        | DeepReadonly<GetOfficesOfficeIdGetParameters>
    ): OperationInfiniteData<GetOfficesOfficeIdGetData, GetOfficesOfficeIdGetParameters> | undefined;
    /** @summary Get */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetOfficesOfficeIdGetSchema,
            GetOfficesOfficeIdGetData,
            TInfinite,
            GetOfficesOfficeIdGetParameters,
            GetOfficesOfficeIdGetError
          >
        | QueryFiltersByQueryKey<
            GetOfficesOfficeIdGetSchema,
            GetOfficesOfficeIdGetData,
            TInfinite,
            GetOfficesOfficeIdGetParameters,
            GetOfficesOfficeIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetOfficesOfficeIdGetSchema, GetOfficesOfficeIdGetParameters>,
            data:
              | NoInfer<OperationInfiniteData<GetOfficesOfficeIdGetData, GetOfficesOfficeIdGetParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetOfficesOfficeIdGetSchema, GetOfficesOfficeIdGetParameters>,
            data: GetOfficesOfficeIdGetData | undefined,
          ]
        >;
    /** @summary Get */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetOfficesOfficeIdGetSchema, GetOfficesOfficeIdGetParameters>
        | DeepReadonly<GetOfficesOfficeIdGetParameters>
    ): QueryState<GetOfficesOfficeIdGetData, GetOfficesOfficeIdGetError> | undefined;
    /** @summary Get */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetOfficesOfficeIdGetParameters>
        | ServiceOperationInfiniteQueryKey<GetOfficesOfficeIdGetSchema, GetOfficesOfficeIdGetParameters>
    ):
      | QueryState<
          OperationInfiniteData<GetOfficesOfficeIdGetData, GetOfficesOfficeIdGetParameters>,
          GetOfficesOfficeIdGetError
        >
      | undefined;
    /** @summary Get */
    setQueryData(
      parameters:
        | DeepReadonly<GetOfficesOfficeIdGetParameters>
        | ServiceOperationQueryKey<GetOfficesOfficeIdGetSchema, GetOfficesOfficeIdGetParameters>,
      updater: Updater<
        NoInfer<GetOfficesOfficeIdGetData> | undefined,
        NoInfer<DeepReadonly<GetOfficesOfficeIdGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetOfficesOfficeIdGetData | undefined;
    /** @summary Get */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetOfficesOfficeIdGetParameters>
        | ServiceOperationInfiniteQueryKey<GetOfficesOfficeIdGetSchema, GetOfficesOfficeIdGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetOfficesOfficeIdGetData, GetOfficesOfficeIdGetParameters>> | undefined,
        | NoInfer<DeepReadonly<OperationInfiniteData<GetOfficesOfficeIdGetData, GetOfficesOfficeIdGetParameters>>>
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetOfficesOfficeIdGetData, GetOfficesOfficeIdGetParameters> | undefined;
    /** @summary Get */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetOfficesOfficeIdGetSchema,
            GetOfficesOfficeIdGetData,
            TInfinite,
            GetOfficesOfficeIdGetParameters,
            GetOfficesOfficeIdGetError
          >
        | QueryFiltersByQueryKey<
            GetOfficesOfficeIdGetSchema,
            GetOfficesOfficeIdGetData,
            TInfinite,
            GetOfficesOfficeIdGetParameters,
            GetOfficesOfficeIdGetError
          >,
      updater: Updater<NoInfer<GetOfficesOfficeIdGetData> | undefined, NoInfer<GetOfficesOfficeIdGetData> | undefined>,
      options?: SetDataOptions
    ): Array<GetOfficesOfficeIdGetData | undefined>;
    /** @summary Get */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetOfficesOfficeIdGetSchema,
        GetOfficesOfficeIdGetData,
        TInfinite,
        GetOfficesOfficeIdGetParameters,
        GetOfficesOfficeIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetOfficesOfficeIdGetSchema,
            GetOfficesOfficeIdGetData,
            TInfinite,
            GetOfficesOfficeIdGetParameters,
            GetOfficesOfficeIdGetError
          >
        | QueryFiltersByQueryKey<
            GetOfficesOfficeIdGetSchema,
            GetOfficesOfficeIdGetData,
            TInfinite,
            GetOfficesOfficeIdGetParameters,
            GetOfficesOfficeIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetOfficesOfficeIdGetSchema,
            GetOfficesOfficeIdGetData,
            TInfinite,
            GetOfficesOfficeIdGetParameters,
            GetOfficesOfficeIdGetError
          >
        | QueryFiltersByQueryKey<
            GetOfficesOfficeIdGetSchema,
            GetOfficesOfficeIdGetData,
            TInfinite,
            GetOfficesOfficeIdGetParameters,
            GetOfficesOfficeIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetOfficesOfficeIdGetSchema,
            GetOfficesOfficeIdGetData,
            TInfinite,
            GetOfficesOfficeIdGetParameters,
            GetOfficesOfficeIdGetError
          >
        | QueryFiltersByQueryKey<
            GetOfficesOfficeIdGetSchema,
            GetOfficesOfficeIdGetData,
            TInfinite,
            GetOfficesOfficeIdGetParameters,
            GetOfficesOfficeIdGetError
          >
    ): void;
    /** @summary Get */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetOfficesOfficeIdGetSchema,
            GetOfficesOfficeIdGetData,
            TInfinite,
            GetOfficesOfficeIdGetParameters,
            GetOfficesOfficeIdGetError
          >
        | QueryFiltersByQueryKey<
            GetOfficesOfficeIdGetSchema,
            GetOfficesOfficeIdGetData,
            TInfinite,
            GetOfficesOfficeIdGetParameters,
            GetOfficesOfficeIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetOfficesOfficeIdGetSchema,
            GetOfficesOfficeIdGetData,
            TInfinite,
            GetOfficesOfficeIdGetParameters,
            GetOfficesOfficeIdGetError
          >
        | QueryFiltersByQueryKey<
            GetOfficesOfficeIdGetSchema,
            GetOfficesOfficeIdGetData,
            TInfinite,
            GetOfficesOfficeIdGetParameters,
            GetOfficesOfficeIdGetError
          >
    ): number;
    schema: GetOfficesOfficeIdGetSchema;
    types: {
      parameters: GetOfficesOfficeIdGetParameters;
      data: GetOfficesOfficeIdGetData;
      error: GetOfficesOfficeIdGetError;
    };
  };
  /** @summary Update */
  updateOfficesOfficeIdPatch: {
    /** @summary Update */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateOfficesOfficeIdPatchBody,
        UpdateOfficesOfficeIdPatchParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateOfficesOfficeIdPatchSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateOfficesOfficeIdPatchBody,
          UpdateOfficesOfficeIdPatchParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<UpdateOfficesOfficeIdPatchData, UpdateOfficesOfficeIdPatchError>>
    ): Promise<RequestFnResponse<UpdateOfficesOfficeIdPatchData, UpdateOfficesOfficeIdPatchError>>;
    /** @summary Update */
    getMutationKey(
      parameters: DeepReadonly<UpdateOfficesOfficeIdPatchParameters> | void
    ): ServiceOperationMutationKey<UpdateOfficesOfficeIdPatchSchema, UpdateOfficesOfficeIdPatchParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.officesService.updateOfficesOfficeIdPatch.useMutation({
     *     path: {
     *         office_id: officeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.officesService.updateOfficesOfficeIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         office_id: officeId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateOfficesOfficeIdPatchBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateOfficesOfficeIdPatchParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateOfficesOfficeIdPatchSchema,
        UpdateOfficesOfficeIdPatchData,
        UpdateOfficesOfficeIdPatchParameters,
        TVariables,
        OperationError<UpdateOfficesOfficeIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateOfficesOfficeIdPatchData,
      OperationError<UpdateOfficesOfficeIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.officesService.updateOfficesOfficeIdPatch.useMutation({
     *     path: {
     *         office_id: officeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.officesService.updateOfficesOfficeIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         office_id: officeId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<UpdateOfficesOfficeIdPatchBody, UpdateOfficesOfficeIdPatchParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateOfficesOfficeIdPatchSchema,
        UpdateOfficesOfficeIdPatchData,
        UpdateOfficesOfficeIdPatchParameters,
        TVariables,
        OperationError<UpdateOfficesOfficeIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateOfficesOfficeIdPatchData,
      OperationError<UpdateOfficesOfficeIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateOfficesOfficeIdPatchTotal = qraft.officesService.updateOfficesOfficeIdPatch.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateOfficesOfficeIdPatchTotal = qraft.officesService.updateOfficesOfficeIdPatch.useIsMutating({
     *     parameters: {
     *         path: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateOfficesOfficeIdPatchBody,
            UpdateOfficesOfficeIdPatchData,
            UpdateOfficesOfficeIdPatchParameters,
            OperationError<UpdateOfficesOfficeIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateOfficesOfficeIdPatchSchema,
            UpdateOfficesOfficeIdPatchBody,
            UpdateOfficesOfficeIdPatchData,
            UpdateOfficesOfficeIdPatchParameters,
            OperationError<UpdateOfficesOfficeIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateOfficesOfficeIdPatchPendingMutationVariables = qraft.officesService.updateOfficesOfficeIdPatch.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateOfficesOfficeIdPatchMutationData = qraft.officesService.updateOfficesOfficeIdPatch.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 office_id: officeId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateOfficesOfficeIdPatchData,
        OperationError<UpdateOfficesOfficeIdPatchError>,
        MutationVariables<UpdateOfficesOfficeIdPatchBody, UpdateOfficesOfficeIdPatchParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateOfficesOfficeIdPatchBody,
            UpdateOfficesOfficeIdPatchData,
            UpdateOfficesOfficeIdPatchParameters,
            OperationError<UpdateOfficesOfficeIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateOfficesOfficeIdPatchSchema,
            UpdateOfficesOfficeIdPatchBody,
            UpdateOfficesOfficeIdPatchData,
            UpdateOfficesOfficeIdPatchParameters,
            OperationError<UpdateOfficesOfficeIdPatchError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateOfficesOfficeIdPatchData,
          OperationError<UpdateOfficesOfficeIdPatchError>,
          MutationVariables<UpdateOfficesOfficeIdPatchBody, UpdateOfficesOfficeIdPatchParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Update */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateOfficesOfficeIdPatchBody,
            UpdateOfficesOfficeIdPatchData,
            UpdateOfficesOfficeIdPatchParameters,
            OperationError<UpdateOfficesOfficeIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateOfficesOfficeIdPatchSchema,
            UpdateOfficesOfficeIdPatchBody,
            UpdateOfficesOfficeIdPatchData,
            UpdateOfficesOfficeIdPatchParameters,
            OperationError<UpdateOfficesOfficeIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.officesService.updateOfficesOfficeIdPatch.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             office_id: officeId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.officesService.updateOfficesOfficeIdPatch.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateOfficesOfficeIdPatchBody,
              UpdateOfficesOfficeIdPatchData,
              UpdateOfficesOfficeIdPatchParameters,
              OperationError<UpdateOfficesOfficeIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateOfficesOfficeIdPatchSchema,
              UpdateOfficesOfficeIdPatchBody,
              UpdateOfficesOfficeIdPatchData,
              UpdateOfficesOfficeIdPatchParameters,
              OperationError<UpdateOfficesOfficeIdPatchError>,
              TContext
            >
      ):
        | Mutation<
            UpdateOfficesOfficeIdPatchData,
            UpdateOfficesOfficeIdPatchError,
            MutationVariables<UpdateOfficesOfficeIdPatchBody, UpdateOfficesOfficeIdPatchParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateOfficesOfficeIdPatchBody,
              UpdateOfficesOfficeIdPatchData,
              UpdateOfficesOfficeIdPatchParameters,
              OperationError<UpdateOfficesOfficeIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateOfficesOfficeIdPatchSchema,
              UpdateOfficesOfficeIdPatchBody,
              UpdateOfficesOfficeIdPatchData,
              UpdateOfficesOfficeIdPatchParameters,
              OperationError<UpdateOfficesOfficeIdPatchError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateOfficesOfficeIdPatchData,
          UpdateOfficesOfficeIdPatchError,
          MutationVariables<UpdateOfficesOfficeIdPatchBody, UpdateOfficesOfficeIdPatchParameters>,
          TContext
        >
      >;
    };
    schema: UpdateOfficesOfficeIdPatchSchema;
    types: {
      parameters: UpdateOfficesOfficeIdPatchParameters;
      data: UpdateOfficesOfficeIdPatchData;
      error: UpdateOfficesOfficeIdPatchError;
      body: UpdateOfficesOfficeIdPatchBody;
    };
  };
  /** @summary Create */
  createOfficesPost: {
    /** @summary Create */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<CreateOfficesPostBody, CreateOfficesPostParameters, TMeta, TSignal>,
      client?: (
        schema: CreateOfficesPostSchema,
        options: ServiceOperationMutationFnOptions<CreateOfficesPostBody, CreateOfficesPostParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<CreateOfficesPostData, CreateOfficesPostError>>
    ): Promise<RequestFnResponse<CreateOfficesPostData, CreateOfficesPostError>>;
    /** @summary Create */
    getMutationKey(
      parameters: DeepReadonly<CreateOfficesPostParameters> | void
    ): ServiceOperationMutationKey<CreateOfficesPostSchema, CreateOfficesPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.officesService.createOfficesPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.officesService.createOfficesPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateOfficesPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateOfficesPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateOfficesPostSchema,
        CreateOfficesPostData,
        CreateOfficesPostParameters,
        TVariables,
        OperationError<CreateOfficesPostError>,
        TContext
      >
    ): UseMutationResult<CreateOfficesPostData, OperationError<CreateOfficesPostError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.officesService.createOfficesPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.officesService.createOfficesPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<CreateOfficesPostBody, CreateOfficesPostParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateOfficesPostSchema,
        CreateOfficesPostData,
        CreateOfficesPostParameters,
        TVariables,
        OperationError<CreateOfficesPostError>,
        TContext
      >
    ): UseMutationResult<CreateOfficesPostData, OperationError<CreateOfficesPostError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createOfficesPostTotal = qraft.officesService.createOfficesPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createOfficesPostTotal = qraft.officesService.createOfficesPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateOfficesPostBody,
            CreateOfficesPostData,
            CreateOfficesPostParameters,
            OperationError<CreateOfficesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateOfficesPostSchema,
            CreateOfficesPostBody,
            CreateOfficesPostData,
            CreateOfficesPostParameters,
            OperationError<CreateOfficesPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createOfficesPostPendingMutationVariables = qraft.officesService.createOfficesPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createOfficesPostMutationData = qraft.officesService.createOfficesPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateOfficesPostData,
        OperationError<CreateOfficesPostError>,
        MutationVariables<CreateOfficesPostBody, CreateOfficesPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateOfficesPostBody,
            CreateOfficesPostData,
            CreateOfficesPostParameters,
            OperationError<CreateOfficesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateOfficesPostSchema,
            CreateOfficesPostBody,
            CreateOfficesPostData,
            CreateOfficesPostParameters,
            OperationError<CreateOfficesPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateOfficesPostData,
          OperationError<CreateOfficesPostError>,
          MutationVariables<CreateOfficesPostBody, CreateOfficesPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateOfficesPostBody,
            CreateOfficesPostData,
            CreateOfficesPostParameters,
            OperationError<CreateOfficesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateOfficesPostSchema,
            CreateOfficesPostBody,
            CreateOfficesPostData,
            CreateOfficesPostParameters,
            OperationError<CreateOfficesPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.officesService.createOfficesPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.officesService.createOfficesPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateOfficesPostBody,
              CreateOfficesPostData,
              CreateOfficesPostParameters,
              OperationError<CreateOfficesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateOfficesPostSchema,
              CreateOfficesPostBody,
              CreateOfficesPostData,
              CreateOfficesPostParameters,
              OperationError<CreateOfficesPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateOfficesPostData,
            CreateOfficesPostError,
            MutationVariables<CreateOfficesPostBody, CreateOfficesPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateOfficesPostBody,
              CreateOfficesPostData,
              CreateOfficesPostParameters,
              OperationError<CreateOfficesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateOfficesPostSchema,
              CreateOfficesPostBody,
              CreateOfficesPostData,
              CreateOfficesPostParameters,
              OperationError<CreateOfficesPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateOfficesPostData,
          CreateOfficesPostError,
          MutationVariables<CreateOfficesPostBody, CreateOfficesPostParameters>,
          TContext
        >
      >;
    };
    schema: CreateOfficesPostSchema;
    types: {
      parameters: CreateOfficesPostParameters;
      data: CreateOfficesPostData;
      error: CreateOfficesPostError;
      body: CreateOfficesPostBody;
    };
  };
  /** @summary Upload File */
  uploadFileOfficesOfficeIdFilesPost: {
    /** @summary Upload File */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UploadFileOfficesOfficeIdFilesPostBody,
        UploadFileOfficesOfficeIdFilesPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UploadFileOfficesOfficeIdFilesPostSchema,
        options: ServiceOperationMutationFnOptions<
          UploadFileOfficesOfficeIdFilesPostBody,
          UploadFileOfficesOfficeIdFilesPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<UploadFileOfficesOfficeIdFilesPostData, UploadFileOfficesOfficeIdFilesPostError>>
    ): Promise<RequestFnResponse<UploadFileOfficesOfficeIdFilesPostData, UploadFileOfficesOfficeIdFilesPostError>>;
    /** @summary Upload File */
    getMutationKey(
      parameters: DeepReadonly<UploadFileOfficesOfficeIdFilesPostParameters> | void
    ): ServiceOperationMutationKey<
      UploadFileOfficesOfficeIdFilesPostSchema,
      UploadFileOfficesOfficeIdFilesPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Upload File
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.officesService.uploadFileOfficesOfficeIdFilesPost.useMutation({
     *     path: {
     *         office_id: officeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.officesService.uploadFileOfficesOfficeIdFilesPost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         office_id: officeId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UploadFileOfficesOfficeIdFilesPostBody, TContext = unknown>(
      parameters: DeepReadonly<UploadFileOfficesOfficeIdFilesPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        UploadFileOfficesOfficeIdFilesPostSchema,
        UploadFileOfficesOfficeIdFilesPostData,
        UploadFileOfficesOfficeIdFilesPostParameters,
        TVariables,
        OperationError<UploadFileOfficesOfficeIdFilesPostError>,
        TContext
      >
    ): UseMutationResult<
      UploadFileOfficesOfficeIdFilesPostData,
      OperationError<UploadFileOfficesOfficeIdFilesPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Upload File
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.officesService.uploadFileOfficesOfficeIdFilesPost.useMutation({
     *     path: {
     *         office_id: officeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.officesService.uploadFileOfficesOfficeIdFilesPost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         office_id: officeId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        UploadFileOfficesOfficeIdFilesPostBody,
        UploadFileOfficesOfficeIdFilesPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UploadFileOfficesOfficeIdFilesPostSchema,
        UploadFileOfficesOfficeIdFilesPostData,
        UploadFileOfficesOfficeIdFilesPostParameters,
        TVariables,
        OperationError<UploadFileOfficesOfficeIdFilesPostError>,
        TContext
      >
    ): UseMutationResult<
      UploadFileOfficesOfficeIdFilesPostData,
      OperationError<UploadFileOfficesOfficeIdFilesPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Upload File
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const uploadFileOfficesOfficeIdFilesPostTotal = qraft.officesService.uploadFileOfficesOfficeIdFilesPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const uploadFileOfficesOfficeIdFilesPostTotal = qraft.officesService.uploadFileOfficesOfficeIdFilesPost.useIsMutating({
     *     parameters: {
     *         path: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UploadFileOfficesOfficeIdFilesPostBody,
            UploadFileOfficesOfficeIdFilesPostData,
            UploadFileOfficesOfficeIdFilesPostParameters,
            OperationError<UploadFileOfficesOfficeIdFilesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UploadFileOfficesOfficeIdFilesPostSchema,
            UploadFileOfficesOfficeIdFilesPostBody,
            UploadFileOfficesOfficeIdFilesPostData,
            UploadFileOfficesOfficeIdFilesPostParameters,
            OperationError<UploadFileOfficesOfficeIdFilesPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Upload File
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const uploadFileOfficesOfficeIdFilesPostPendingMutationVariables = qraft.officesService.uploadFileOfficesOfficeIdFilesPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const uploadFileOfficesOfficeIdFilesPostMutationData = qraft.officesService.uploadFileOfficesOfficeIdFilesPost.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 office_id: officeId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UploadFileOfficesOfficeIdFilesPostData,
        OperationError<UploadFileOfficesOfficeIdFilesPostError>,
        MutationVariables<UploadFileOfficesOfficeIdFilesPostBody, UploadFileOfficesOfficeIdFilesPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UploadFileOfficesOfficeIdFilesPostBody,
            UploadFileOfficesOfficeIdFilesPostData,
            UploadFileOfficesOfficeIdFilesPostParameters,
            OperationError<UploadFileOfficesOfficeIdFilesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UploadFileOfficesOfficeIdFilesPostSchema,
            UploadFileOfficesOfficeIdFilesPostBody,
            UploadFileOfficesOfficeIdFilesPostData,
            UploadFileOfficesOfficeIdFilesPostParameters,
            OperationError<UploadFileOfficesOfficeIdFilesPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UploadFileOfficesOfficeIdFilesPostData,
          OperationError<UploadFileOfficesOfficeIdFilesPostError>,
          MutationVariables<UploadFileOfficesOfficeIdFilesPostBody, UploadFileOfficesOfficeIdFilesPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Upload File */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UploadFileOfficesOfficeIdFilesPostBody,
            UploadFileOfficesOfficeIdFilesPostData,
            UploadFileOfficesOfficeIdFilesPostParameters,
            OperationError<UploadFileOfficesOfficeIdFilesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UploadFileOfficesOfficeIdFilesPostSchema,
            UploadFileOfficesOfficeIdFilesPostBody,
            UploadFileOfficesOfficeIdFilesPostData,
            UploadFileOfficesOfficeIdFilesPostParameters,
            OperationError<UploadFileOfficesOfficeIdFilesPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Upload File
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.officesService.uploadFileOfficesOfficeIdFilesPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             office_id: officeId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.officesService.uploadFileOfficesOfficeIdFilesPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UploadFileOfficesOfficeIdFilesPostBody,
              UploadFileOfficesOfficeIdFilesPostData,
              UploadFileOfficesOfficeIdFilesPostParameters,
              OperationError<UploadFileOfficesOfficeIdFilesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UploadFileOfficesOfficeIdFilesPostSchema,
              UploadFileOfficesOfficeIdFilesPostBody,
              UploadFileOfficesOfficeIdFilesPostData,
              UploadFileOfficesOfficeIdFilesPostParameters,
              OperationError<UploadFileOfficesOfficeIdFilesPostError>,
              TContext
            >
      ):
        | Mutation<
            UploadFileOfficesOfficeIdFilesPostData,
            UploadFileOfficesOfficeIdFilesPostError,
            MutationVariables<UploadFileOfficesOfficeIdFilesPostBody, UploadFileOfficesOfficeIdFilesPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UploadFileOfficesOfficeIdFilesPostBody,
              UploadFileOfficesOfficeIdFilesPostData,
              UploadFileOfficesOfficeIdFilesPostParameters,
              OperationError<UploadFileOfficesOfficeIdFilesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UploadFileOfficesOfficeIdFilesPostSchema,
              UploadFileOfficesOfficeIdFilesPostBody,
              UploadFileOfficesOfficeIdFilesPostData,
              UploadFileOfficesOfficeIdFilesPostParameters,
              OperationError<UploadFileOfficesOfficeIdFilesPostError>,
              TContext
            >
      ): Array<
        Mutation<
          UploadFileOfficesOfficeIdFilesPostData,
          UploadFileOfficesOfficeIdFilesPostError,
          MutationVariables<UploadFileOfficesOfficeIdFilesPostBody, UploadFileOfficesOfficeIdFilesPostParameters>,
          TContext
        >
      >;
    };
    schema: UploadFileOfficesOfficeIdFilesPostSchema;
    types: {
      parameters: UploadFileOfficesOfficeIdFilesPostParameters;
      data: UploadFileOfficesOfficeIdFilesPostData;
      error: UploadFileOfficesOfficeIdFilesPostError;
      body: UploadFileOfficesOfficeIdFilesPostBody;
    };
  };
}
/** @summary List For Org */
export const listForOrgOfficesListGet = {
  schema: {
    method: 'get',
    url: '/offices/list',
    security: ['HTTPBearer'],
  },
} as {
  schema: ListForOrgOfficesListGetSchema;
  [QraftServiceOperationsToken]: OfficesService['listForOrgOfficesListGet'];
};
/** @summary List All */
export const listAllOffices = {
  schema: {
    method: 'get',
    url: '/offices/list_all',
    security: ['HTTPBearer'],
  },
} as {
  schema: ListAllOfficesSchema;
  [QraftServiceOperationsToken]: OfficesService['listAllOffices'];
};
/** @summary Get Active */
export const getActiveOfficesActiveGet = {
  schema: {
    method: 'get',
    url: '/offices/active',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetActiveOfficesActiveGetSchema;
  [QraftServiceOperationsToken]: OfficesService['getActiveOfficesActiveGet'];
};
/** @summary Get */
export const getOfficesOfficeIdGet = {
  schema: {
    method: 'get',
    url: '/offices/{office_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetOfficesOfficeIdGetSchema;
  [QraftServiceOperationsToken]: OfficesService['getOfficesOfficeIdGet'];
};
/** @summary Update */
export const updateOfficesOfficeIdPatch = {
  schema: {
    method: 'patch',
    url: '/offices/{office_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateOfficesOfficeIdPatchSchema;
  [QraftServiceOperationsToken]: OfficesService['updateOfficesOfficeIdPatch'];
};
/** @summary Create */
export const createOfficesPost = {
  schema: {
    method: 'post',
    url: '/offices',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateOfficesPostSchema;
  [QraftServiceOperationsToken]: OfficesService['createOfficesPost'];
};
/** @summary Upload File */
export const uploadFileOfficesOfficeIdFilesPost = {
  schema: {
    method: 'post',
    url: '/offices/{office_id}/files',
    mediaType: ['multipart/form-data'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UploadFileOfficesOfficeIdFilesPostSchema;
  [QraftServiceOperationsToken]: OfficesService['uploadFileOfficesOfficeIdFilesPost'];
};
export const officesService = {
  listForOrgOfficesListGet,
  listAllOffices,
  getActiveOfficesActiveGet,
  getOfficesOfficeIdGet,
  updateOfficesOfficeIdPatch,
  createOfficesPost,
  uploadFileOfficesOfficeIdFilesPost,
} as const;
type ListForOrgOfficesListGetSchema = {
  method: 'get';
  url: '/offices/list';
  security: ['HTTPBearer'];
};
type ListForOrgOfficesListGetParameters = undefined;
type ListForOrgOfficesListGetData = paths['/offices/list']['get']['responses']['200']['content']['application/json'];
type ListForOrgOfficesListGetError = unknown;
type ListAllOfficesSchema = {
  method: 'get';
  url: '/offices/list_all';
  security: ['HTTPBearer'];
};
type ListAllOfficesParameters = undefined;
type ListAllOfficesData = paths['/offices/list_all']['get']['responses']['200']['content']['application/json'];
type ListAllOfficesError = unknown;
type GetActiveOfficesActiveGetSchema = {
  method: 'get';
  url: '/offices/active';
  security: ['HTTPBearer'];
};
type GetActiveOfficesActiveGetParameters = undefined;
type GetActiveOfficesActiveGetData = paths['/offices/active']['get']['responses']['200']['content']['application/json'];
type GetActiveOfficesActiveGetError = unknown;
type GetOfficesOfficeIdGetSchema = {
  method: 'get';
  url: '/offices/{office_id}';
  security: ['HTTPBearer'];
};
type GetOfficesOfficeIdGetParameters = paths['/offices/{office_id}']['get']['parameters'];
type GetOfficesOfficeIdGetData =
  paths['/offices/{office_id}']['get']['responses']['200']['content']['application/json'];
type GetOfficesOfficeIdGetError =
  paths['/offices/{office_id}']['get']['responses']['422']['content']['application/json'];
type UpdateOfficesOfficeIdPatchSchema = {
  method: 'patch';
  url: '/offices/{office_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateOfficesOfficeIdPatchParameters = paths['/offices/{office_id}']['patch']['parameters'];
type UpdateOfficesOfficeIdPatchData =
  paths['/offices/{office_id}']['patch']['responses']['200']['content']['application/json'];
type UpdateOfficesOfficeIdPatchError =
  paths['/offices/{office_id}']['patch']['responses']['422']['content']['application/json'];
type UpdateOfficesOfficeIdPatchBody =
  paths['/offices/{office_id}']['patch']['requestBody']['content']['application/json'];
type CreateOfficesPostSchema = {
  method: 'post';
  url: '/offices';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateOfficesPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateOfficesPostData = paths['/offices']['post']['responses']['200']['content']['application/json'];
type CreateOfficesPostError = paths['/offices']['post']['responses']['422']['content']['application/json'];
type CreateOfficesPostBody = paths['/offices']['post']['requestBody']['content']['application/json'];
type UploadFileOfficesOfficeIdFilesPostSchema = {
  method: 'post';
  url: '/offices/{office_id}/files';
  mediaType: ['multipart/form-data'];
  security: ['HTTPBearer'];
};
type UploadFileOfficesOfficeIdFilesPostParameters = paths['/offices/{office_id}/files']['post']['parameters'];
type UploadFileOfficesOfficeIdFilesPostData =
  paths['/offices/{office_id}/files']['post']['responses']['200']['content']['application/json'];
type UploadFileOfficesOfficeIdFilesPostError =
  paths['/offices/{office_id}/files']['post']['responses']['422']['content']['application/json'];
type UploadFileOfficesOfficeIdFilesPostBody =
  | paths['/offices/{office_id}/files']['post']['requestBody']['content']['multipart/form-data']
  | FormData;
